import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "./style/Signup.css";
import MapModal from "./MapModal";
import { db } from "../firebase";
import { collection, doc, setDoc } from "firebase/firestore";
import LoadingSpinner from "./elements/LoadingSpinner";

export default function Signup() {
  const nameRef = useRef();
  const emailRef = useRef();
  const contactRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const addressRef = useRef();
  const { signup, currentUser, logout } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const navigate = useNavigate();
  const [agreedToPrivacyPolicy, setAgreedToPrivacyPolicy] = useState(false);
  document.title ='Signup - Hentian Komuniti';
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('signupData'));
    if (savedData) {
      nameRef.current.value = savedData.name;
      emailRef.current.value = savedData.email;
      contactRef.current.value = savedData.contact;
      passwordRef.current.value = savedData.password;
      passwordConfirmRef.current.value = savedData.passwordConfirm;
      setSelectedLocation(savedData.selectedLocation);
      setAgreedToPrivacyPolicy(savedData.agreedToPrivacyPolicy);
    }
  }, []);
  
  const handleDelete =() =>{
    localStorage.removeItem("signupData")
  }

  const handleOpenMapModal = () => {
    setShowMapModal(true);
  };

  const handleCloseMapModal = () => {
    setShowMapModal(false);
  };

  const handleSelectLocation = (location) => {
    setSelectedLocation(location);
    console.log("Address in form", selectedLocation);
  };

  async function handleSubmit(e) {
    console.log("Address in form", selectedLocation);
    if (!agreedToPrivacyPolicy) {
      setError("You must agree to the privacy policy");
      return;
    }
    e.preventDefault();
    const characterRegex = /[a-zA-Z]/;
    const specialSymbolRegex = /[!@#$%^&*(),.?":{}|<>]/;
    const numberRegex = /[0-9]/;    
    
    if (!validateContactNumber(contactRef.current.value)) {
      setError("Contact number must be at least 8 digits");
      setLoading(false);
      return;
    }
    if (
      passwordRef.current.value.length < 6 ||
      passwordConfirmRef.current.value.length < 6
    ) {
      setLoading(false);
      return setError("Passwords must longer than 6 character");
    }
    if (
      !characterRegex.test(passwordRef.current.value) ||
      !specialSymbolRegex.test(passwordRef.current.value) ||
      !numberRegex.test(passwordRef.current.value)
    ) {
      setLoading(false);
      return setError("Password must contain at least one character, one special symbol (eg: ! , | @), and one number");
    }
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      setLoading(false);
      return setError("Passwords do not match");
    }


    try {
      setError("");
      setLoading(true);
      try {
        const user = await signup(
          emailRef.current.value,
          passwordRef.current.value
        );
        console.log('user', user);
        const contact = contactRef.current.value;
        const name = nameRef.current.value;
        const address = addressRef.current.value;
        const latLng = [selectedLocation[2].lat, selectedLocation[2].lng];
        const email = emailRef.current.value;
        console.log("ssss", selectedLocation[2].lat);
        console.log('User id ',user.uid);

        const merchantData = {
          name: name,
          contact: contact,
          address: address,
          latLng: latLng,
          email:email
        };
        console.log(merchantData);

        await setDoc(doc(db, "merchants", user.uid), merchantData);
        setLoading(false);
        alert("Please check your inbox and verify your email address to access all features of our app.");
        logout();
        handleDelete();
        navigate("/login");
      } catch (error) {
        console.error(error);
        setLoading(false)
        setError("Failed to create an account");
      }
    } catch (error) {
      console.log(error);
      setError("Failed to create an account");
      setLoading(false);
    }
  }

  function validateContactNumber(contact) {
    // Regular expression to match a number with a minimum length of 8 digits
    const contactRegex = /^\d{8,}$/;
    return contactRegex.test(contact);
  }

  const handleSaveData = () => {
    const signupData = {
      name: nameRef.current.value,
      email: emailRef.current.value,
      contact: contactRef.current.value,
      password: passwordRef.current.value,
      passwordConfirm: passwordConfirmRef.current.value,
      selectedLocation: selectedLocation,
      agreedToPrivacyPolicy: agreedToPrivacyPolicy,
    };
    localStorage.setItem('signupData', JSON.stringify(signupData));
  };

  return (
    <div className="body">
      <div className="row body">
        <div className="col-12 col-sm-7 d-flex justify-content-center align-items-center custom-container">
          <Card className="border-0 card ">
            <Card.Body>
              <h2 id="title" className="title text-center mb-4 me-5">
                Sign Up As Merchant
              </h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mt-1" id="name">
                  <Form.Label className="custom-label mb-0">Name</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="text"
                    ref={nameRef}
                    required
                  />
                </Form.Group>
                <Form.Group className="mt-1" id="email">
                  <Form.Label className="custom-label mb-0">Email</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="email"
                    ref={emailRef}
                    required
                  />
                </Form.Group>
                <Form.Group className="mt-1" id="contact">
                  <Form.Label className="custom-label mb-0">Contact</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="tel"
                    ref={contactRef}
                    required
                  />
                </Form.Group>
                <div className="row">
                  <Form.Group className="col-12 col-sm-6 mt-1" id="password">
                    <Form.Label className="custom-label mb-0">
                      Password
                    </Form.Label>
                    <Form.Control
                      className="custom-input"
                      type="password"
                      ref={passwordRef}
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    className="col-12 col-sm-6 mt-1"
                    id="password-confirm"
                  >
                    <Form.Label className="custom-label mb-0">
                      Confirm Password
                    </Form.Label>
                    <Form.Control
                      className="custom-input"
                      type="password"
                      ref={passwordConfirmRef}
                      required
                    />
                  </Form.Group>
                </div>

                <Form.Group className="mt-1" id="address">
                  <Form.Label className="custom-label mb-0">Address</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="text"
                    value={selectedLocation[0]}
                    onChange={handleSelectLocation}
                    ref={addressRef}
                    required
                    disabled="true"
                  />
                </Form.Group>
                <div className="mt-2 d-flex justify-content-end">
                  <Button id="select-location" onClick={handleOpenMapModal}>
                    Select Location on Map
                  </Button>
                </div>
                <Form.Group className="mt-3" controlId="formBasicCheckbox">
                  <Form.Check
                    type="checkbox"
                    label={
                      <>
                        I agree to the{" "}
                        <Link to="/privacy-policy" onClick={handleSaveData}>
                          Privacy Policy
                        </Link>
                      </>
                    }
                    onChange={(e) => setAgreedToPrivacyPolicy(e.target.checked)}
                    required
                  />
                </Form.Group>
                {error && <Alert variant="danger mt-2">{error}</Alert>}
                <Button
                  className="mt-4"
                  id="signupBtn"
                  disabled={loading}
                  type="submit"
                >
                  Sign Up
                </Button>
              </Form>
              <div className="text-center mt-2">
                <Link to="/login" onClick={handleDelete}>
                  <Button className="backToLoginBtn" id="btl">
                    BACK TO LOGIN
                  </Button>
                </Link>
              </div>
              <MapModal
                show={showMapModal}
                onHide={handleCloseMapModal}
                onSelectLocation={handleSelectLocation}
              />
            </Card.Body>
          </Card>
        </div>
        <LoadingSpinner show={loading} spinnerColor="#4F6F52" />

        <div className="right col-0 col-sm-5 d-none d-sm-block right-side-signup">
          <p className="small-title">Hentian Komuniti</p>
          <div className="white-line"></div>
        </div>
      </div>
    </div>
  );
}
